/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { APIEndpoint } from "../../../utils/axios";
import { FilterBodyTemplate } from "../../../utils/configs";
import { DataGrid,LoaderPop, NGODatePicker, EditModal } from "../../../common";
import { useTranslation } from 'react-i18next';
import usePermissions from '../../../utils/userPermissions';
import CustomSelect from '../../../common/CustomSelect';

const Columns = [
  { field: 'currencyCode', headerName: 'pages.cashRegisterContent.cashDrawer.tableColumns.currencyCode', suppressSizeToFit:true,resizable:true,flex:1,minWidth:100 },
  { field: 'currencyName', headerName: 'pages.cashRegisterContent.cashDrawer.tableColumns.currencyName', suppressSizeToFit:true,resizable:true,flex:1,minWidth:100},
  { field: 'openingBalance', headerName: 'pages.cashRegisterContent.cashDrawer.tableColumns.openingBalance', cellStyle: params => {
    if (params && params?.data?.openingBalance>0) {
    return {color: '#04AA6D'};
    }
    else if((params && params.data?.openingBalance<0) || (params && params.data?.openingBalance<params.data?.closingBalance)){
    return {color:" #d9534f"};
    }else if(params&& params.data?.closingBalance===params.data?.openingBalance){
      return {color: '#04AA6D'};
    }
    else{
      return null;
    }
}, suppressSizeToFit:true,resizable:true,flex:1,minWidth:100},
  { field: 'deposit', headerName: 'pages.cashRegisterContent.cashDrawer.tableColumns.deposit',flex:1, suppressSizeToFit:true,resizable:true,minWidth:100},
  { field: 'bankTransfer', headerName: 'pages.cashRegisterContent.cashDrawer.tableColumns.bankTransfer',flex:1, suppressSizeToFit:true,resizable:true,minWidth:100 },
  { field: 'variance', headerName: 'pages.cashRegisterContent.cashDrawer.tableColumns.variance', suppressSizeToFit:true,flex:1,resizable:true ,minWidth:100},
  { field: 'closingBalance', headerName: 'pages.cashRegisterContent.cashDrawer.tableColumns.closingBalance',  cellStyle: params => {
  if ((params && params.data?.closingBalance<0) ||(params && params.data?.closingBalance<params.data?.openingBalance)) {
  return {color:" #d9534f"};
  }
  else if(params&& params.data?.closingBalance>params.data?.openingBalance){
  return {color: '#04AA6D'};
  }else if(params&& params.data?.closingBalance===params.data?.openingBalance){
  return {color: '#04AA6D'};
  }
  else{
  return null;
  }
},minWidth:200,suppressSizeToFit:true,flex:1}
]
const FormFields = [
  { label: 'Airport', attribute: 'airportId', type: 'selectSearch2', required: true }, 
]

export const CashDrawersPage = (props) => {
  const { t,ready } = useTranslation();
  const [state, setState] = useState({ cashDrawerList: null, data: null, showCreateDialog: false,modalFormStatusObj:{text:''} });
  const [filterDate, setFilterData] = useState(new Date());
  const [cashDrawer, setCashDrawer] = useState('');
  const [resetDataSource, setResetDataSource] = useState(false)
  const [noResultsMessage, setNoResultsMessage] = useState("")
  const [isDropDownOpen,setIsDropdownOpen]=useState(false);
  const [ModalContHeight,setModalContHeight]=useState({height:'auto'})
  const { hasPermission: createCashDrawers } = usePermissions('create', "configuration.fsc.cash-drawers");

  useEffect(() => {
    fetchCashDrawersList();
    fetchAirports();
    setNoResultsMessage(t('pages.cashRegisterContent.cashDrawer.noselectionWarning'))
  }, [ready])

  useEffect(() => {
    if (filterDate!==null && cashDrawer.length>0) {
      setResetDataSource(!resetDataSource)
    }else{
      setResetDataSource(!resetDataSource)
    }
  }, [filterDate, cashDrawer])

  useEffect(() => {
    setResetDataSource(!resetDataSource)   
  }, [noResultsMessage])

  useEffect(() => {
    if(isDropDownOpen){
      setModalContHeight({height:'35vh'})
    }else{
      setModalContHeight({height:'auto'})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]);

  const fetchCashDrawersList = async () => {
    try {
       const res = await APIEndpoint.get('cashRegister/cashDrawers');
    const list = (res.result || []).map((_) => ({ value: _.id, label: _.value }));
    list.unshift({ label: t('pages.cashRegisterContent.cashDrawer.selectPlaceholder'), value: '' })
    setState((_) => ({ ..._, cashDrawerList: list }))
    } catch (error) {

    }

  }

  const fetchCashBalance = async () => {
    const body = { ...FilterBodyTemplate, filters: [] };
    body.filters = [{ date: filterDate }, { cashDrawerId: cashDrawer }]
    body.limit = 200;
    if(filterDate!==null && cashDrawer.length>0){
    const res = await APIEndpoint.post('cashRegister/balance', body);
      if(res && !res.count){
        setNoResultsMessage("No Data");
      }
      return res
    }else{
    setNoResultsMessage(t('pages.cashRegisterContent.cashDrawer.noselectionWarning'))
    return {
      "count": 0,
      "items": []
    }
}
  }
  const fetchAirports = async () => {
    try {
      const res = await APIEndpoint.get('airports');
    const list = (res.items || []).map((_) => ({ value: _.id, label: `${_.locationCode}(${_.locationName})` }));
    list.unshift({ label: t('pages.pagesContent.airports.selectPlaceholder'), value: '' })
    setState((_) => ({ ..._, airports: list }))
    } catch (error) {

    }

  }
  const handleOnchangeCashDrawers=()=>{
    setState((_) => ({ ..._, modalFormStatusObj:{text:''} }))
    }
  const handleCreateNewDrawer = async (e, values) => {
    if(!values || !values.airportId){
      setState((_) => ({ ..._,modalFormStatusObj:{error: t('pages.cashRegisterContent.cashDrawer.selectAirport')} }))
      return;
    }
    try {
       const res = await APIEndpoint.post('cashRegister/cashDrawers', values);
         if (res) {
          setState((_) => ({ ..._,modalFormStatusObj:{text:res.message} }))
          fetchCashDrawersList()
       }
       setTimeout(() => {
        setState((_) => ({ ..._, showCreateDialog: false,modalFormStatusObj:{text:''}}))
      }, 2000)
    } catch (error) {
        if(error.message) {
          const responseData = JSON.parse(error.message);
          const errorMessage = responseData?.data?.message;
          setState((_) => ({ ..._,modalFormStatusObj:{error:errorMessage} }))
        } else{
          setState((_) => ({ ..._,modalFormStatusObj:{text:'Failed to create new drawer'} }))
        }
    }
    }

  return (
    <div className="flexCol width100 ag-theme-alpine-dark cash-reg">
      {
        state.cashDrawerList === null ?
          <LoaderPop />
          :
          <div className='flexCol full-flex'>
            <div className='flexRow alignItemsCenter justifyContentSpaceBetween'>
              <div className='flexRow alignItemsCenter'>
         {createCashDrawers?   <button className='add-item-button'
                  onClick={() => {
                    fetchAirports();
                    setState((_) => ({ ..._, showCreateDialog: true }))
                  }}>
                  {t('pages.cashRegisterContent.cashDrawer.addCashDrawer')}
                </button>:<></>}
                <div className='margLeft6'>
                <CustomSelect
                  options={state.cashDrawerList}
                  placeHolder="Search Cash Drawer"
                  onChange={(e) => {
                    setCashDrawer(e?.value|| "");
                  }}
                />
                </div>
                
              </div>
              <NGODatePicker
                value={filterDate}
                maxDate={new Date()}
                onChange={(e) => {
                  setFilterData(e.target.value);
                }} />
            </div>

              <DataGrid
                columnResize
                showDefaultFilters={false}
                enableGridSearch={false}
                className='full-flex'
                columns={Columns}
                getRows={fetchCashBalance}
                resetDataSource={resetDataSource}
                noResultsMessage={noResultsMessage}
              />

          </div>
      }
      {
        Boolean(state.showCreateDialog) && Boolean(state.airports) && (
          <EditModal
            buttonLabel="Create"
            className='create-drawer'
            title={t('pages.cashRegisterContent.cashDrawer.newDrawerTitle')}
            showFieldsInColumn={true}
            customContentHeight={ModalContHeight}
            setIsDropdownOpen={setIsDropdownOpen}
            onClose={() => {
              setState((_) => ({ ..._, showCreateDialog: false,modalFormStatusObj:{text:''} }))
            }}
            modalFormStatusObj={state?.modalFormStatusObj}
            onSubmit={handleCreateNewDrawer}
            onChange={handleOnchangeCashDrawers}
            fields={FormFields.map((_) => {
              return { ..._, options: state.airports }
            })}
          />
        )
      }
    {
    !ready &&<div className='overlay_hide sub'></div>
    }
    </div>
  )
}